import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VisitModeMstApi } from '../api/visitModeMst.api';
import { switchMap, map } from 'rxjs/operators';

import { VisitModeMst,VisitModeMstData } from '../../../interfaces/masters/visitModeMst';

@Injectable()
export class VisitModeMstService extends VisitModeMstData  {

  constructor(private api: VisitModeMstApi) {
    super();
  } 
  list(url: string): Observable<VisitModeMst[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<VisitModeMst>{
      return this.api.getById(url);
  }
  
  create(url: string, data:VisitModeMst): Observable<VisitModeMst[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:VisitModeMst): Observable<VisitModeMst> {
    return this.api.update(url,data);
  } 


  
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
